<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters } from "vuex";
import Vue from 'vue';
import excel from 'vue-excel-export';
Vue.use(excel)
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Store Items Stock Levels",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Inventory",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Stock Levels",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Item Name",
          sortable: true,
        },
        {
          key: "opening",
          label: "Opening Stock",
          sortable: true,
        },
        {
          key: "new",
          label: "New Stock",
          sortable: true,
        },
        {
          key: "issued",
          label: "Issued Stock",
          sortable: true,
        },
        {
          key: "returns",
          label: "Return Stock",
          sortable: true,
        },
        {
          key: "losses",
          label: "Losses",
          sortable: true,
        },
        {
          key: "balance",
          label: "Available Stock",
          sortable: true,
        },
      ],
      data: {
        item: "",
        date: new Date().toJSON().slice(0,10).replace(/-/g,'-'),
        quantity: 1,
        by: "",
        type: 3,
      },
      itemError: "",
      qtyError: "",
      modal: "",
    };
  },
  computed: {
    ...mapGetters("inventory", ["Levels","StoreItems","SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.Levels ? this.Levels.length : 1;
    },
  },
  watch: {
    SaveStatus(newValue) {
      if (newValue) {
        this.closeModal(this.modal);
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Levels ? this.Levels.length : 1;
  },
  methods: {
    ...mapActions({
      FetchStoreLevels: "inventory/fetchStoreLevel",
      FetchStoreItems: "inventory/fetchStoreItems",
      Submit: "inventory/submitLossReturn",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.Levels ? this.Levels.length : 1;
      this.currentPage = 1;
    },
    resetErrors() {
      this.qtyError = "";
      this.itemError = "";
    },

    resetModal() {
      this.data.item = "";
      this.data.quantity = 1;
      this.data.type = 3;
      this.data.by = 1;
    },
    register(modal) {
      if (this.data.quantity == "") {
        this.qtyError = "Quantity field can't be empty";
        return;
      } else {
        this.qtyError = "";
      }
      if (this.data.item == "") {
        this.itemError = "Item field can't be empty'";
        return;
      } else {
        this.itemError = "";
      }
      this.modal = modal;
      this.Submit(this.data);
    },
    closeModal(modalId) {
        this.resetErrors();
        this.resetModal();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchStoreLevels();
    this.FetchStoreItems();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_fees_settings')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">
                  Stock Levels
                </h3>
              </div>
              <div class="col-3">
               <button
                  v-b-modal.add-modal
                  class="btn btn-sm btn-primary float-end"
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_fees_settings')
                    )
                  "
                >
                  <i class="fa fa-plus"></i> Add New
                </button>
                <export-excel
                      :data   = "Levels"
                      name    = "Store Stock Levels.xls">
                      <b-btn variant="success" class="btn-sm">
                      <i class="fa fa-download"></i>
                      Excel
                      </b-btn>
                  </export-excel>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="Levels ? Levels : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

<b-modal
        id="add-modal"
        hide-footer
        @hidden="resetModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_expenses')
          )
        "
      >
        <template #modal-title> Register Loss/Return </template>
        <div class="form-group mb-2">
            <label>Store Item <span class="required">*</span></label>
            <div class="input-group">
                <model-list-select
                required
                :list="StoreItems ? StoreItems : []"
                v-model="data.item"
                option-value="id"
                option-text="name"
                class="mb-2"
                @input="resetErrors()"
                placeholder="Select Store Item"
                >
                </model-list-select>
            </div>
            <div class="text-danger" v-if="itemError">
                <em>{{ itemError }}</em>
            </div>
            </div>
            <div class="form-group mb-2">
            <label>Quantity Returned/Lost<span class="required">*</span></label>
            <div class="input-group">
                <input
                type="text"
                placeholder="Enter Quantity"
                class="form-control"
                @input="resetErrors()"
                v-model="data.quantity"
                />
            </div>
            <div class="text-danger" v-if="qtyError">
                <em>{{ qtyError }}</em>
            </div>
        </div>
        <div class="form-group mb-2">
          <label>Type</label>
          <div class="input-group">
              <select class="form-control" v-model="data.type">
                <option value="3">Loss</option>
                <option value="4">Return</option>
              </select>
          </div>
          </div>
        <div class="form-group mb-2">
          <label>Date</label>
          <div class="input-group">
              <input
              type="date"
              class="form-control"
              v-model="data.date"
              />
          </div>
          </div>
          <div class="form-group mb-2">
          <label>Loss/Returned By <span class="required">*</span></label>
          <div class="input-group">
              <input
              type="text"
              placeholder="Enter Person who brought/lost the item"
              class="form-control"
              v-model="data.by"
                @keyup.enter="register('add-modal')"
              />
          </div>
          </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-danger btn-sm"
            data-dismiss="modal"
            @click="closeModal('add-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            @click="register('add-modal')"
          >
            <i class="fa fa-check"></i>
            Submit
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
            ></b-spinner>
          </button>
        </div>
      </b-modal>

    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style scoped>
.required {
  color: red;
}
</style>
